require('./brokerCustomWalletLeaveEditionModal.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @utils
const { FormattedText } = require('core/i18n').i18n;

// @component
const OKModal = require('components/commons/OKModal/OKModal');

class BrokerCustomWalletLeaveEditionModal extends React.Component {
    constructor(props) {
        super(props);

        this.handleAccept = this.handleAccept.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    buildModalLeaveEdition() {
        const { walletName } = this.props;

        if (walletName) {
            const modalContent = (
                <React.Fragment>
                    <div className="broker-custom-wallet-leave-edition__modal-text">
                        <div>
                            <FormattedText value="brokerCustomWallet-leaveEditionWalletText"
                                injectedStrings={[walletName]}
                            />
                        </div>
                        <div>
                            <FormattedText value="brokerCustomWallet-leaveEditionWalletText2" />
                        </div>
                    </div>
                    <div className="broker-custom-wallet-leave-edition__modal-info">
                        <FormattedText value="brokerCustomWallet-leaveEditionWalletInfo" />
                    </div>
                </React.Fragment>
            );

            return (
                <OKModal
                    content={modalContent}
                    footerType="navigation"
                    isOpen={true}
                    onCloseCallback={this.handleCancel}
                    onPrimaryButtonClick={this.handleAccept}
                    onSecondaryButtonClick={this.handleCancel}
                    primaryButtonText="brokerCustomWallet-buttonCancelLeaveEditionWallet"
                    secondaryButtonText="brokerCustomWallet-buttonConfirmLeaveEditionWallet"
                    title="brokerCustomWallet-leaveEditionWalletTitle"
                />
            );
        }
    }

    handleAccept() {
        this.props.onAccept();
    }

    handleCancel() {
        this.props.onCancel();
    }

    render() {
        return this.buildModalLeaveEdition();
    }

}

BrokerCustomWalletLeaveEditionModal.propTypes = {
    walletName: PropTypes.string.isRequired,
    onAccept: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};

module.exports = BrokerCustomWalletLeaveEditionModal;
